import { gateway } from "../../../../gateway";

export const updateProvider = async ({ token, data , id }) => {
  try {
    const res = await gateway.patch(
      `/providers/${id}`,
      data,
      {
        headers: {
          Authorization: `${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
